function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Tabela");

var SvgTable = function SvgTable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("rect", {
    x: 63.41,
    y: 30.94,
    width: 8.71,
    height: 6.53,
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M87.65,30.94H73.29v6.53H90.35V33.65A2.71,2.71,0,0,0,87.65,30.94Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("rect", {
    x: 63.41,
    y: 38.65,
    width: 8.71,
    height: 8.71,
    style: {
      fill: "#ccc"
    }
  }), React.createElement("rect", {
    x: 63.41,
    y: 48.53,
    width: 8.71,
    height: 8.71,
    style: {
      fill: "#ccc"
    }
  }), React.createElement("rect", {
    x: 63.41,
    y: 58.41,
    width: 8.71,
    height: 8.71,
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "14 47.35 22.71 47.35 22.71 38.65 14 38.65 12.82 38.65 5.65 38.65 5.65 47.35 12.82 47.35 14 47.35",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M14,67.12h8.71V58.41H5.65v8.18a3.07,3.07,0,0,0,0,.53H14Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "14 57.23 22.71 57.23 22.71 48.53 14 48.53 12.82 48.53 5.65 48.53 5.65 57.23 12.82 57.23 14 57.23",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M14,37.47h8.71V30.94H8.35a2.71,2.71,0,0,0-2.7,2.71v3.82H14Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "33.77 67.12 42.47 67.12 42.47 58.41 33.77 58.41 32.59 58.41 23.88 58.41 23.88 67.12 32.59 67.12 33.77 67.12",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "33.77 47.35 42.47 47.35 42.47 38.65 33.77 38.65 32.59 38.65 23.88 38.65 23.88 47.35 32.59 47.35 33.77 47.35",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "33.77 37.47 42.47 37.47 42.47 30.94 33.77 30.94 32.59 30.94 23.88 30.94 23.88 37.47 32.59 37.47 33.77 37.47",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "33.77 57.23 42.47 57.23 42.47 48.53 33.77 48.53 32.59 48.53 23.88 48.53 23.88 57.23 32.59 57.23 33.77 57.23",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "53.53 47.35 62.23 47.35 62.23 38.65 53.53 38.65 52.35 38.65 43.65 38.65 43.65 47.35 52.35 47.35 53.53 47.35",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "53.53 37.47 62.23 37.47 62.23 30.94 53.53 30.94 52.35 30.94 43.65 30.94 43.65 37.47 52.35 37.47 53.53 37.47",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "53.53 57.23 62.23 57.23 62.23 48.53 53.53 48.53 52.35 48.53 43.65 48.53 43.65 57.23 52.35 57.23 53.53 57.23",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "53.53 67.12 62.23 67.12 62.23 58.41 53.53 58.41 52.35 58.41 43.65 58.41 43.65 67.12 52.35 67.12 53.53 67.12",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M62.24,68.29h-56a2.68,2.68,0,0,0,2.08,1H72.12v-1H62.24Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M82,68.29H73.29v1H87.65a2.68,2.68,0,0,0,2.08-1H82Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "82 38.65 73.29 38.65 73.29 47.35 82 47.35 83.18 47.35 90.35 47.35 90.35 38.65 83.18 38.65 82 38.65",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M82,58.41H73.29v8.71h17a3.07,3.07,0,0,0,0-.53V58.41H82Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "82 48.53 73.29 48.53 73.29 57.23 82 57.23 83.18 57.23 90.35 57.23 90.35 48.53 83.18 48.53 82 48.53",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TABLE.b929815e.svg";
export { ForwardRef as ReactComponent };